import * as React from "react";
import { cn } from "../utils/cn";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => {
    const baseClass =
      "flex h-11 w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-60 placeholder:text-gray-400";
    const errorClass = error ? "border-danger-500 focus-visible:ring-danger-500" : "";
    return (
      <div className="flex w-full flex-col gap-1">
        <input ref={ref} className={cn(baseClass, errorClass, className)} {...props} />
        {error ? <span className="text-xs text-danger-600">{error}</span> : null}
      </div>
    );
  }
);

Input.displayName = "Input";
